import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.css"; // Import CSS

export default function Login() {
    const [credentials, setCredentials] = useState({ username: "", password: "" });
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Tài khoản mặc định (có thể thay đổi để lấy từ database)
    const adminUser = { username: "admin", password: "1234" };

    const handleLogin = (e) => {
        e.preventDefault();
        if (credentials.username === adminUser.username && credentials.password === adminUser.password) {
            localStorage.setItem("isAuthenticated", "true"); // Lưu trạng thái đăng nhập
            navigate("/giaithuong"); // Chuyển hướng sau khi đăng nhập
        } else {
            setError("Sai tên đăng nhập hoặc mật khẩu!");
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h2>Đăng nhập</h2>
                {error && <p className="error-message">{error}</p>}
                <form onSubmit={handleLogin}>
                    <input
                        className="login-input"
                        type="text"
                        placeholder="Tên đăng nhập"
                        value={credentials.username}
                        onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                        required
                    />
                    <input
                        className="login-input"
                        type="password"
                        placeholder="Mật khẩu"
                        value={credentials.password}
                        onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                        required
                    />
                    <button type="submit">Đăng nhập</button>
                </form>
            </div>
        </div>
    );
}
